import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { games as mockGames } from '../mock';
import { useGamesPlayed } from '../hooks/useGamesPlayed';

export default function Games() {
  const { items, loading } = useGamesPlayed();
  const games = !loading && items.length > 0 ? items : mockGames;

  return (
    <section id="games" className="relative py-24 px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <div className="inline-flex items-center gap-2 text-violet-300 text-sm font-semibold mb-2">
            <Gamepad2 className="w-4 h-4" /> GAMES
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight">
            Wat speel ik op stream?
          </h2>
          <p className="text-zinc-400 mt-3 max-w-xl">
            Van Sea of Thieves piraterij tot Trackmania timeattacks. Variety blijft het devies.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {games.map((g) => (
            <div
              key={g.id || g.name}
              className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
              data-testid={`game-card-${(g.name || '').toLowerCase().replace(/\s+/g, '-')}`}
            >
              {g.art ? (
                <img
                  src={g.art}
                  alt={g.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-violet-900/40 to-zinc-900" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              {g.tag ? (
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-white/10 backdrop-blur text-white border border-white/20">
                  {g.tag}
                </div>
              ) : null}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="text-white font-bold leading-tight">{g.name}</div>
                {g.hours ? (
                  <div className="text-xs text-zinc-300 mt-1">{g.hours}u op stream</div>
                ) : null}
                {g.steam_hours != null && g.steam_hours > 0 ? (
                  <div
                    className="text-[11px] text-sky-300/90 mt-0.5 flex items-center gap-1"
                    data-testid={`game-steam-hours-${(g.name || '').toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current" aria-hidden="true">
                      <path d="M12 2a10 10 0 0 0-9.94 8.86l5.4 2.23a2.84 2.84 0 0 1 1.6-.49h.14l2.4-3.48v-.05a3.78 3.78 0 1 1 3.78 3.78h-.09l-3.42 2.45c0 .04.01.08.01.12a2.85 2.85 0 1 1-5.65-.6L2.27 13.3A10 10 0 1 0 12 2zm-3.46 15.16-1.23-.51a2.16 2.16 0 0 0 1.06 1.04 2.13 2.13 0 0 0 2.78-1.15 2.13 2.13 0 0 0-1.15-2.78l-1.27-.53a2.5 2.5 0 0 1 1.92.05 2.51 2.51 0 0 1-1.96 4.62zm10.99-6.94a2.52 2.52 0 1 1-2.52-2.52 2.52 2.52 0 0 1 2.52 2.52z" />
                    </svg>
                    {g.steam_hours}u op Steam
                  </div>
                ) : null}
              </div>
              <div className="absolute inset-0 border-2 border-violet-500/0 group-hover:border-violet-500/60 rounded-xl transition-colors" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
